<ng-container *ngIf="statisticList$ | async as statisticList">
  <div class="d-flex flex-column h-100 modal-content">
    <apm-section-title title="{{ '446062' | apmTranslate }}" icon="t_notes"></apm-section-title>
    <mat-stepper class="stepper-content-modal-xl" #stepper [linear]="true">
      <mat-step *ngFor="let group of statisticList; let i = index" [completed]="!!selectedStatistics[group.groupCode]">
        <ng-template matStepLabel>{{ group.resourceId | apmTranslate }}</ng-template>
        <apm-statistic-data-item
          [title]="group.resourceId | apmTranslate"
          [statisticDataList]="group.statistics ?? []"
          [selectedStatisticsCode]="selectedStatistics[group.groupCode]"
          [dependsOn]="group.previousGroupCode ? selectedStatistics[group.previousGroupCode] : null"
          (onSelectStatistic)="onStatisticSelected($event, group.groupCode)"
        ></apm-statistic-data-item>
      </mat-step>
    </mat-stepper>
    <div class="ms-auto mt-auto d-flex">
      <apm-button
        class="me-2"
        *ngIf="hasDatasheetMoreDetails"
        variant="secondary"
        (click)="skipAnswers(statisticList)"
        >{{ '446065' | apmTranslate }}</apm-button
      >
      <apm-button class="me-2" variant="secondary" [disabled]="stepper.selectedIndex === 0" (click)="goPrev()">{{
        '446066' | apmTranslate
      }}</apm-button>
      <apm-button
        *ngIf="stepper.selectedIndex !== statisticList.length - 1"
        [disabled]="!stepper.selected?.completed"
        (click)="goNext()"
        >{{ '444727' | apmTranslate }}</apm-button
      >
      <apm-button
        *ngIf="stepper.selectedIndex === statisticList.length - 1"
        [disabled]="!stepper.selected?.completed"
        (click)="confirm()"
        >{{ '444735' | apmTranslate }}</apm-button
      >
    </div>
  </div>
</ng-container>
